import { validateContentReference } from '@gitbook/app-content-refs';
import { Fragment, NODE_MISSING_FRAGMENT, Schema } from '@gitbook/slate';

import { createParagraph } from '../paragraph';
import { BLOCK_FILE, BLOCK_PARAGRAPH, FRAGMENT_CAPTION } from '../types';

const validateFileRef = validateContentReference(['file']);

/**
 * Schema to validate files.
 */
export const schema = Schema.create({
    blocks: {
        [BLOCK_FILE]: {
            parent: { objects: ['document', 'block', 'fragment'] },
            isVoid: true,
            data: {
                ref: validateFileRef,
            },
            fragments: {
                keys: [FRAGMENT_CAPTION],
                nodes: [{ types: [BLOCK_PARAGRAPH], min: 1, max: 1 }],
            },
            normalize: (change, violation, { node }) => {
                switch (violation) {
                    case NODE_MISSING_FRAGMENT: {
                        return change.setFragmentByKey(
                            // @ts-expect-error
                            node.key,
                            Fragment.create({
                                fragment: FRAGMENT_CAPTION,
                                nodes: [createParagraph()],
                            })
                        );
                    }
                }
            },
        },
    },
});
